import React from "react";
import "./Preloader.css";

class Preloader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: props.loading,
      fadingOut: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.loading && !this.props.loading) {
      this.setState({ fadingOut: true });

      setTimeout(() => {
        this.setState({ visible: false, fadingOut: false });
      }, 1000);
    }

    if (!prevProps.loading && this.props.loading) {
      this.setState({ visible: true });
    }
  }

  render() {
    if (!this.state.visible) return null;

    const className = `preloader-overlay ${this.state.fadingOut ? "fade-out" : ""}`;

    return (
      <div className={className}>
        <div className="ripple-loader">
          <div></div>
          <div></div>
        </div>
      </div>
    );
  }
}

export default Preloader;
